const normalizeRowId = (id) => String(id);

export const getSelectionModelForPage = (savedSelection, pageRows = []) => {
  const rows = Array.isArray(pageRows) ? pageRows : [];
  const pageIds = rows.map((row) => normalizeRowId(row.id));
  if (savedSelection === "selected All") {
    return pageIds;
  }
  if (!Array.isArray(savedSelection) || savedSelection.length === 0) {
    return [];
  }
  const pageIdSet = new Set(pageIds);
  return savedSelection
    .filter((item) => pageIdSet.has(normalizeRowId(item.id)))
    .map((item) => normalizeRowId(item.id));
};

export const applySelectionChange = ({
  ids,
  tableData,
  saveSelection,
  page,
  from,
}) => {
  const rows = Array.isArray(tableData) ? tableData : [];
  const currentPageIds = new Set(rows.map((row) => normalizeRowId(row.id)));
  const selectedIDs = new Set(ids.map(normalizeRowId));
  const selectedRows = rows.filter((item) =>
    selectedIDs.has(normalizeRowId(item.id))
  );

  if (!ids.length) {
    if (saveSelection === "selected All") {
      return { nextSelection: [], selectAll: false, showGroupAlert: false };
    }
    if (Array.isArray(saveSelection)) {
      const remaining = saveSelection.filter(
        (item) => !currentPageIds.has(normalizeRowId(item.id))
      );
      return {
        nextSelection: remaining,
        selectAll: remaining.length > 0,
        showGroupAlert: false,
      };
    }
    return { nextSelection: [], selectAll: false, showGroupAlert: false };
  }

  if (saveSelection === "selected All") {
    return {
      nextSelection: selectedRows,
      selectAll: selectedRows.length > 0,
      showGroupAlert: false,
    };
  }

  const base = Array.isArray(saveSelection) ? saveSelection : [];
  const fromOtherPages = base.filter(
    (item) => !currentPageIds.has(normalizeRowId(item.id))
  );
  const merged = [...fromOtherPages, ...selectedRows];
  const seen = new Set();
  const deduped = merged.filter((item) => {
    const rowId = normalizeRowId(item.id);
    if (seen.has(rowId)) return false;
    seen.add(rowId);
    return true;
  });

  return {
    nextSelection: deduped,
    selectAll: deduped.length > 0,
    showGroupAlert: false,
  };
};
